import React, { useEffect, useState, useContext } from 'react';
import clsx from 'clsx';
import { Link as GatsbyLink } from 'gatsby';
import { Badge, Link } from '@printdeal/ui-library';
import { addEventEntry, addDataLayerEntry } from '@printdeal/data-layer-manager';

import { useCart } from '@printdeal/checkout-frontend';
import { getMainLineItems } from '@printdeal/checkout-shared';
import useSystemPages from '../../../hooks/useSystemPages';
import { HeaderContext } from './context';

interface CartNavigationProps {
  className?: string;
}

const CartNavigation = ({ className }: CartNavigationProps) => {
  const [cartPage] = useSystemPages('cart');
  const [lineItemCount, setLineItemCount] = useState(0);
  const { isSticky } = useContext(HeaderContext);
  const { cart } = useCart();

  useEffect(() => {
    setLineItemCount(cart ? getMainLineItems(cart).length : 0);
  }, [cart]);

  const cartButtonClickEventGA = () => {
    const eventCategory = isSticky ? 'header_cart_sticky' : 'header_cart';
    addDataLayerEntry(eventCategory, {
      eventAction: 'click',
    });
    addEventEntry({
      eventCategory,
      eventAction: 'click',
    });
  };

  return (
    <Link
      as={GatsbyLink}
      to={cartPage.path}
      onClick={cartButtonClickEventGA}
      variant="secondary"
      iconBefore="shopping-cart"
      className={clsx('pd-relative', className)}
    >
      {lineItemCount > 0 && (
        <Badge variant="primary-circle" className="pd-absolute -pd-top-3 pd-left-3">
          {lineItemCount}
        </Badge>
      )}
      <span className="pd-sr-only">{cartPage.title}</span>
    </Link>
  );
};

export default CartNavigation;
